import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { ApplicationContext } from "@context/ApplicationContext";
import ErrorIcon from "@components/Icons/ErrorIcon";
import InfoIcon from "@components/Icons/InfoIcon";
import SuccessIcon from "@components/Icons/SuccessIcon";

import "./style.scss";

const AlertMessage = ({
                          message = null,
                          additionalClass,
                          type = "success",
                          showIcon = true,
                          messageList = null,
                          link = "",
                          fromPathName = "",
                          displayEmail = false,
                      }) => {
    const { whiteLabel } = useContext(ApplicationContext);

    const typeClass = type === "error" ? "error" : type === "info" ? "info" : "success";

    const icon = type === "error"
        ? <ErrorIcon />
        : type === "info"
            ? <InfoIcon />
            : <SuccessIcon className="bi bi-check-circle-fill" />;

    if (link) {
        message = (
            <Link
                className="alert-message__link"
                to={{ pathname: "/login", state: { from: fromPathName } }}
            >
                {message}
            </Link>
        );
    }

    return message && (
        <div className={`alert-message__wrapper alert-message__wrapper--${typeClass} alert-message__wrapper--${additionalClass}`}>
            <div className={`alert-message alert-message__${typeClass}`}>
                {showIcon && (
                    <span className="alert-message__icon">{icon}</span>
                )}
                <div className="alert-message__content">
                    {message}
                    {messageList && (
                        <ul className="alert-message__message-list">
                            {messageList.map((item, idx) => (
                                <li key={idx}>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                    {displayEmail && whiteLabel?.support_email ? (
                        <a
                            className="alert-message__link"
                            href={`mailto:${whiteLabel?.support_email}`}
                        >
                            {whiteLabel?.support_email}
                        </a>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

AlertMessage.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    type: PropTypes.oneOf(["success", "error", "info"]),
    showIcon: PropTypes.bool,
    messageList: PropTypes.array,
    link: PropTypes.string,
    fromPathName: PropTypes.string,
    displayEmail: PropTypes.bool
};

export default AlertMessage;
